/**
 * POST one or more files into a deck's assets/ via the assets API. Shared by
 * the command bar (attach-and-reference) and the Assets drawer (manage media)
 * so the FormData build + error-shape handling lives in one place.
 *
 * Returns the parsed body's `{ uploaded, errors }` on success. Throws on HTTP
 * failure with the same message the call sites used before: the server's
 * `error` field, falling back to the status line.
 */
import type { AssetUploadPayload } from '../../shared/api.ts';
import { api } from './api.ts';

export async function uploadAssets(slug: string, files: Iterable<File>): Promise<AssetUploadPayload> {
  const form = new FormData();
  for (const f of files) form.append('file', f);
  const data = await api.postForm<Partial<AssetUploadPayload>>(`/api/assets/${slug}`, form);
  return { uploaded: data.uploaded || [], errors: data.errors || [] };
}
